export default __webpack_public_path__ + "static/media/about-page-img.9a9d0819.png";